import { Provider } from '@angular/core';

import { MainApi } from '@mark/web-contracts';

import { CommonGrpcContractFactory } from './common.service.provider';

export const AuthV2GrpcContractProvider: Provider = {
  provide: MainApi.AuthV2GrpcWebContractClient,
  useFactory: CommonGrpcContractFactory(MainApi.AuthV2GrpcWebContractClient, 'mainApi'),
};
